export const summayPerBrand = [
  {
    id: "product_name",
    label: "Brand",
    sortable: true,
  },
  {
    id: "total",
    label: "Brand Total Count",
    sortable: true,
  },

  {
    id: "peso_value",
    label: "Total Value",
    sortable: true,
  },

  {
    id: "uploaders",
    label: "No. Of Purchasers",
    sortable: true,
  },
  {
    id: "repeat",
    label: "No. Of Repeat Purchasers",
    sortable: true,
  },
];

export const summaryPerSku = [
  {
    id: "product_name",
    label: "SKU",
    sortable: true,
  },
  {
    id: "total",
    label: "Product Count",
    sortable: true,
  },

  {
    id: "peso_value",
    label: "Total Value",
    sortable: true,
  },

  {
    id: "uploaders",
    label: "No. Of Purchasers",
    sortable: true,
  },
  {
    id: "repeat",
    label: "No. Of Repeat Purchasers",
    sortable: true,
  },
];
